const systemRouter = [
  {  
    path: 'epms0100',
    name: 'epms0100',
    component: () => import('@/views/hip/Z/epms0100.vue'),
    meta: { menu_code: 'epms0100', menu_id: 'epms0100', title: 'Home', affix: true }
  }
]

export default systemRouter